__turbopack_context__.v({
  "base": "text-module-scss-module__PT5W9G__base",
  "capitalize": "text-module-scss-module__PT5W9G__capitalize",
  "lowercase": "text-module-scss-module__PT5W9G__lowercase",
  "nowrap": "text-module-scss-module__PT5W9G__nowrap",
  "smallText": "text-module-scss-module__PT5W9G__smallText",
  "uppercase": "text-module-scss-module__PT5W9G__uppercase",
  "verticalAlignTop": "text-module-scss-module__PT5W9G__verticalAlignTop",
});
